import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import { Toast } from '../../../classess/notifications/toast';
import { GlobalFormats } from '../../../classess/main/globalFormats';

import {
    badgetStatusGeneric, getProcessButtons, dataTableLanguaje, setDateTimeFormatGlobal, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, handleResponseMessageAsync, settings, styles, LoadingSection, awaitDelayAsync
} from '../../../helpers/main';
import useAuth from '../../../auth/UseAuth';
import Menu from '../../main/Menu';
import { ToastService } from '../../../services/notifications/toasts/ToastService';
import TableIndex from '../../main/TableIndex';
import AccessDenied from '../../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'Toasts';

export default function Toasts({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const isMount = useRef(false);
    const auth = useAuth();
    const dtToastsId = 'dtToasts';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        add: false,
    });

    const controls = {
        buttons: {
            addToast: {
                id: 'btnAddToast',
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
            },
        },
        icons: {
            addToast: {
                id: 'iconAddToast',
                defaultClass: icons?.fasFa?.plusCircle,
            },
        }
    };
    //#endregion variables

    //#region methods
    //#region notificationstoasts
    const getAddToast = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getAddToast';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, add: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            window.location.href = `${backend?.urls?.notifications}${backend?.urls?.toasts}/${backend?.methods?.notifications?.toasts?.create}/`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, add: false }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getEditToast = async ({
        e = {},
        id = 0,
        description = '',
        rowId = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getEditToast';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            window.location.href = `${backend?.urls?.notifications}${backend?.urls?.toasts}/${id}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const deleteToast = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'deleteToast';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region show message
            let msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.notification?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`
            };

            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: settings.colors.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings.colors.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data (toast)
                        preConfirmResponse = await ToastService.deleteAsync({
                            auth,
                            id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (toast)

                        //#region delete datatable (toast)
                        $(`#${dtToastsId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);
                        //#endregion delete datatable (toast)

                        preConfirmResponse = getResponse({
                            type: 0,
                            msgText: messages?.processCompletedSuccessfully?.[languageObj?.id]
                        });
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        preConfirmResponse.msgText += `Sub method: preConfirm<br/>`;
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire(swalProperties);
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                return;
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion notificationstoasts

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region datatable (set)
            response = setDataTables({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion datatable (set)

            //#region set query code
            response = setQueryCode({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set query code

            //#region get data (toasts)
            response = await ToastService.getAll({
                auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const toasts = response?.result?.toasts || [];
            //#endregion get data (toasts)

            //#region set data (toasts)
            response = setDataInDataTable({ toasts: toasts, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set data (toasts)
        } catch (ex) {
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtToastsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.title?.[languageObj?.id], width: '60%', },
                    { title: labels?.active?.[languageObj?.id], width: '10%', },
                    { title: labels?.authenticated?.[languageObj?.id], width: '10%', },
                    { title: labels?.created?.[languageObj?.id], width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtToastsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id_ = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            $(`#${dtToastsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtToastsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getEditToast({ e: e, id: parseInt(id_), description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            break;
                        case 'delete':
                            deleteToast({ e: e, id: parseInt(id_), description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });

            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        toasts = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            let toastDt = [];

            toasts.forEach((toast) => {
                const modelToast = Toast?.getClass(toast, false);
                const dateTime = setDateTimeFormatGlobal({
                    date: modelToast.register,
                    type: languageObj?.format?.date?.f1,
                    format: languageObj?.format?.time?.type,
                    addTime: false,
                    withSeconds: false,
                    subMethod: currentMethod,
                })?.result;

                const isActive = badgetStatusGeneric({
                    type: modelToast?.isActive ? 0 : 5,
                    value: modelToast?.isActive ? labels?.yes?.[languageObj?.id] : labels?.no?.[languageObj?.id],
                });

                const isAuthenticated = badgetStatusGeneric({
                    type: modelToast?.isAuthenticated ? 0 : 5,
                    value: modelToast?.isAuthenticated ? labels?.yes?.[languageObj?.id] : labels?.no?.[languageObj?.id],
                });

                toastDt.push([
                    modelToast.title,
                    isActive,
                    isAuthenticated,
                    dateTime,
                    getProcessButtons({
                        id: modelToast.id,
                        description: modelToast.title,
                        showDetails: false,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: false,
                        showDelete: true,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        processButtons: [],
                    })?.result,
                ]);
            });

            $(`#${dtToastsId}`)?.DataTable()?.rows?.add(toastDt)?.draw(true);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.settings?.settings} process={app?.views?.notifications?.toast?.toast} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.notificationsToast?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.notificationsToast?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.toasts?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.notificationsToasts} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.notifications?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.comment} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Toasts'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addToast?.id}
                                                            type='button'
                                                            className={process?.showLoading ? `${controls?.buttons?.addToast?.defaultClass} ${settings?.react?.settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.addToast?.defaultClass}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            disabled={process?.showLoading}
                                                            onClick={(e) => getAddToast({ e: e, subMethod: controls?.buttons?.addToast?.id })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {process?.add ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addToast?.id} className={controls?.icons?.addToast?.defaultClass} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtToastsId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div ></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>

            </div>
        </div>
    )
}